const MenuButtonComponent = videojs.getComponent('MenuButton');
const MenuItem = videojs.getComponent('MenuItem');
let localize;

export class AudioDescriptionsButton extends MenuButtonComponent {
    constructor(player, options = {}) {
        localize = player.localize?.bind(player);

        options.title = localize('Audio Tracks');

        super(player, Object.assign({
            name: 'AudioDescriptionsButton',
            title: localize('Audio Descriptions')
        }, options));
        this.addClass('mediasite-player__audio-descriptions-button');
        this.addClass('mediasite-player__custom-controlbar-button');
        this.addClass('vjs-audio-descriptions');
        this.addClass('vjs-audio-button');

        this.controlText(localize('Audio Descriptions'));

        const descriptionsButton = this;

        player.ready(() => {
            player.collapsedButtons?.push({
                pluginName: 'AudioDescriptionsButton',
                label: localize('Audio Descriptions'),
                buttonName: 'AudioDescriptionsButton',
                class: 'vjs-audio-button',
                //Use the lock-showing class, similar to playback rate menu, to show menu even if parent button is hidden
                handler: function () {
                    descriptionsButton.menu.lockShowing();
                    descriptionsButton.menu.focus();
                    descriptionsButton.buttonPressed_ = true;
                }
            });
        });
    }

    createItems() {
        const player = this.player();
        const audioDescriptions = player.audioDescriptions();
        //Main track, no audio descriptions
        let main = new MenuItem(player, {
            label: localize('Main'),
            id: 'main_audio_only',
            selectable: true,
            selected: !audioDescriptions.enabled,
            multiSelectable: false
        });
        main.handleClick = (event) => {
            audioDescriptions.enabled = false;
            this.update();
            player.getDescendant('ControlBar', 'AudioDescriptionsButton')?.focus();
            player.controlsLog().logAction(localize('Audio descriptions disabled'));
        };
        //Audio descriptions track
        let descriptions = new MenuItem(player, {
            label: localize('Audio Descriptions'),
            id: 'enable_audio_descriptions',
            selectable: true,
            selected: audioDescriptions.enabled,
            multiSelectable: false
        });
        descriptions.handleClick = (event) => {
            audioDescriptions.enabled = true;
            this.update();
            player.getDescendant('ControlBar', 'AudioDescriptionsButton')?.focus();
            player.controlsLog().logAction(localize('Audio descriptions enabled'));
        };

        return [main, descriptions];
    }
}